import { createActionGroup, props } from '@ngrx/store';
import {
  BuyerQualification,
  LocaleQuestionMappings,
  QuestionMapping,
} from './decipher-mapping-state.model';

export const DecipherMappingActions = createActionGroup({
  source: 'Decipher Mapping',
  events: {
    Load: props<{ cmp: number }>(),
    'Load Success': props<{
      localeMappings: LocaleQuestionMappings[];
      qualificationsByLocale: Record<string, BuyerQualification[]>;
    }>(),
    'Load Failure': props<{ error: string }>(),

    Save: props<{
      cmp: number;
      locale: string;
      mappings: QuestionMapping[];
    }>(),
    'Save Success': props<{ locale: string; mappings: QuestionMapping[] }>(),
    'Save Failure': props<{ error: string }>(),
  },
});
